import React, { Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2, Voicemail, PhoneOff, UserX } from 'lucide-react';
import { Loan, CallOutcome } from './types';
interface LogCallModalProps {
  loan: Loan | null;
  onClose: () => void;
  onLog: (loan: Loan, outcome: CallOutcome) => void;
}
const outcomes: {
  key: CallOutcome;
  icon: ComponentType<{
    className?: string;
  }>;
  color: string;
  hint: string;
}[] = [{
  key: 'Connected',
  icon: CheckCircle2,
  color: 'emerald',
  hint: 'Borrower engaged — claims lead'
}, {
  key: 'Left Voicemail',
  icon: Voicemail,
  color: 'blue',
  hint: 'Voicemail left, resets call timer'
}, {
  key: 'No Answer',
  icon: PhoneOff,
  color: 'orange',
  hint: 'No pickup, attempt logged'
}, {
  key: 'Bad Number',
  icon: UserX,
  color: 'red',
  hint: 'Flag number for follow-up'
}];
export function LogCallModal({
  loan,
  onClose,
  onLog
}: LogCallModalProps) {
  return <AnimatePresence data-id="element-343">
      {loan && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-slate-950/80 backdrop-blur-sm z-50" onClick={onClose} data-id="element-344" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.96,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.96,
        y: 20
      }} className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-md bg-slate-900 border border-slate-800 rounded-2xl shadow-2xl z-50" data-id="element-345">
            <div className="p-6 border-b border-slate-800 flex items-start justify-between" data-id="element-346">
              <div data-id="element-347">
                <p className="text-xs font-bold uppercase tracking-wider text-orange-400 mb-1" data-id="element-348">
                  Log Call Outcome
                </p>
                <h2 className="text-xl font-bold font-display text-white" data-id="element-349">
                  {loan.borrowerName}
                </h2>
              </div>
              <button onClick={onClose} className="p-2 rounded-lg hover:bg-slate-800 text-slate-400 hover:text-white" data-id="element-350">
                <X className="w-5 h-5" data-id="element-351" />
              </button>
            </div>
            <div className="p-6 grid grid-cols-2 gap-3" data-id="element-352">
              {outcomes.map(o => <button key={o.key} onClick={() => onLog(loan, o.key)} className={`flex flex-col items-start gap-2 p-4 rounded-xl bg-slate-800/50 border border-slate-700 hover:bg-${o.color}-500/10 hover:border-${o.color}-500/40 transition-all text-left group`} data-id="element-353">
                  <o.icon className={`w-6 h-6 text-${o.color}-400`} data-id="element-354" />
                  <div data-id="element-355">
                    <p className="text-sm font-semibold text-white" data-id="element-356">{o.key}</p>
                    <p className="text-[11px] text-slate-400 mt-0.5" data-id="element-357">
                      {o.hint}
                    </p>
                  </div>
                </button>)}
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}